module.exports = __webpack_public_path__ + "img/responsabilidad-fundapec.fd3638ad.png";